import IcoIconsContainer from "../../Componant/Icons/IcoIcon";

const IcoIcons = () => {
  return (
    <div className="page-body">
      <IcoIconsContainer />
    </div>
  );
};

export default IcoIcons;
